import { useState, useEffect, useContext, useRef, ChangeEvent, FormEvent, ClipboardEvent } from "react";
import { useNavigate } from 'react-router-dom';
import { Link, Stack, StackItem } from '@fluentui/react'
import { FluentProvider, Image, Input, Button, Tooltip, Badge, Spinner, Body1, Body2, Body1Strong, Divider, DialogSurface, DialogBody, DialogTitle, DialogContent, Dialog, Card, Text } from '@fluentui/react-components'
import { EyeOff20Filled, Eye20Filled, Open20Regular } from '@fluentui/react-icons'
import { getAuthorisationURLWithQueryParamsAndSetState } from "supertokens-auth-react/recipe/thirdpartyemailpassword";
import { sendOTP } from "../../api/sing_in/otp_func";
import { GlobalContext } from "../../hooks/globalContext";
import { signIn } from "supertokens-web-js/recipe/emailpassword";
import { usePermissionStore } from "../../Store/permissionStore";
import { shouldLoadRoute } from "../../Authentication/RouteProtection";
import { SkeletonSignin } from '../../components/skeleton/skeletonSignin';
import { getLoginAttemptInfo } from "supertokens-web-js/recipe/passwordless";
import { backgroundPosition, cardRadius, parentHome, halfWidth, newLightTheme, newBackground, whites } from '../../styles/customStyles';
import Session from 'supertokens-web-js/recipe/session';
import AppConfig from "../../utility/AppConfig";
import apiCall from "../../utility/api";

interface iUser {
  username: string;
  password: string;
};

// This function consist of mail API call
export const sendMail = async (userEmail: string, action: string) => {
  try {
    const response = await apiCall('/sendEmail', { userEmail, action }, "POST")
    console.log("Success: ", response);
  } catch (error) {
    console.error("Error: ", error);
  }
};

export const Signin = (props: any) => {
  const Navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const signInButtonRef = useRef(null);
  const users = { username: '', password: '' };

  const [isOnline, setIsOnline] = useState(true);
  const [SSODisabled, setSSODisabled] = useState(true);
  const [isAltert, setAlert] = useState(false);
  const [showLink, setShowLink] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loginPage, magicLinkPage] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [blockedError, setBlockedError] = useState(false);
  const [submissionPage, setSubmissionPage] = useState(false);
  const [credentialError, setCredentialError] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [userNotExistsError, setUserNotExistsError] = useState(false);
  const [redirectURL, setRedirectURL] = useState("");
  const [machineName, setMachineName] = useState("");
  const [formError, setFormError] = useState('');
  const [provider, setProvider] = useState('');
  const [error, setError] = useState('');
  const [user, setUser] = useState<iUser>(users);

  const { permissions, setPermissions, removePermissions } = usePermissionStore();

  const urlParams = new URLSearchParams(window.location.search);
  const url = urlParams.get('redirectTo');
  const container = document.querySelector('.ms-Stack.Container') as HTMLElement;

  const EnablePage = () => magicLinkPage(true);
  const SubmissionPageEnable = () => setSubmissionPage(true);
  const handleTogglePassword = () => { setShowPassword(!showPassword); };
  const handlePasswordFocus = () => { setPasswordFocused(true) };

  const serviceNowRedirection = () => {
    if (redirectURL === "troubleShooter") {
      console.log("Check serviceNowUserLoginCheck before navigation", redirectURL);
      Navigate("/manage/troubleshoot/troubleshoot");
      console.log("Check serviceNowUserLoginCheck after navigation", redirectURL);
    } else if (redirectURL === "complianceStatus") {
      Navigate("/manage/devices/compliance_status");
    } else if (redirectURL === "compliancePush") {
      Navigate("/manage/troubleshoot/compliance_policy");
    } else if (redirectURL === "alert") {
      Navigate("/manage/troubleshoot/alert");
    };
  };

  useEffect(() => {
    localStorage.setItem("tenant", contextValue.tenantName);
  }, [contextValue.tenantName]);

  useEffect(() => {
    console.log("Checking serviceNowUserLoginCheck state...");
    async function serviceNowUserLoginCheck() {
      var userName = JSON.parse(localStorage.getItem('userDetails'))?.user_email;
      if (await Session.doesSessionExist() && userName === user.username) {
        await setSessionDetails();
        await serviceNowRedirection();
      } else {
        if (!isDisabled && signInButtonRef.current && machineName?.length > 0) {
          setTimeout(() => {
            signInButtonRef.current.click();
          }, 500);
        }
      }
    }
    redirectURL.length > 0 && serviceNowUserLoginCheck();
  }, [redirectURL]);

  ((url === undefined || url === null || url?.length === 0) && localStorage.getItem('LogedInFrom') === null) && localStorage.clear(); // sign out logic clearing local storage and session
  // sessionStorage.clear();
  var biscuit = document.cookie;
  console.log('http cookie: ', biscuit);

  const checkOTPAndRedirect = async () => {
    const otpSent = await getLoginAttemptInfo() !== undefined;
    console.log('OTP sent: ' + otpSent);
    if (otpSent) {
      Navigate('/verifyotp'); // Redirect to OTP verification page if OTP has been sent
    } else {
      Navigate('/'); // Redirect to email/phone entry page if OTP hasn't been sent
    }
  };

  useEffect(() => {
    redirectURL.length === 0 && checkOTPAndRedirect();
    if (url?.length > 0 && (url === "troubleShooter" || url === "complianceStatus" || url === "compliancePush" || url === "alert")) {
      const userName = urlParams.get('user');
      const psw = urlParams.get('pass');
      const machineName = urlParams.get('machine');
      setMachineName(machineName);
      setUser({ username: userName, password: psw });
      setRedirectURL(url);
    }
  }, [Navigate]);

  const fetchSSOstatuses = async () => {
    try {
      const user_auth = 'SAML';
      const hostname = window.location.hostname; // Get the current hostname
      const body = { hostname: hostname }; // user_auth: user_auth,
      const res = await fetch(`${AppConfig.DASHBOARD_V2_API_URL}/authV2/fetchssoConfig`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body), // Stringify the body object
      });
      const { data, status } = await res.json();
      if (status == 'success' && data[0].sso_status === 1) {
        console.log('Checking data[0]: ', data[0].sso_status)
        setProvider(data[0].idp_full_name);
        setSSODisabled(false);
      } else {
        // setSSODisabled(true);
        console.log('Failed to fetch SSO config...');
      }
    } catch (error) {
      console.error('Error fetching SSO status: ', error);
      // setSSODisabled(true); // Set SSODisabled to false on error
    }
  };

  useEffect(() => {
    fetchSSOstatuses();
  }, []);

  function isEdge() {
    return /Edg(e|e\/|\/)/.test(window.navigator.userAgent)
  };

  function hasNativePasswordToggle() {
    const isEdgeBrowser = /Edg(e)?\//.test(navigator.userAgent); // Check for Microsoft Edge (Chromium-based)
    const eyeIcon = 'passwordReveal' in HTMLInputElement.prototype // Specific check for Edge's native password reveal feature
    return isEdgeBrowser && eyeIcon;
  };

  function attemptRefresh() {
    Session.attemptRefreshingSession().then(success => {
      if (success) {
        // We have new session tokens, so we redirect the user back to where they were.
        const urlParams = new URLSearchParams(window.location.search);
        window.location.href = urlParams.get('redirectBack')!;
      } else {
        window.location.href = "/Dashboard" // We redirect to the login page since the user is now logged out
      }
    })
  };

  useEffect(() => {
    // attemptRefresh()
    ((url === undefined || url === null || url?.length === 0) && localStorage.getItem('LogedInFrom') === null) && localStorage.clear();
    const checkConnection = async () => {
      setIsOnline(navigator.onLine);
      (url === undefined || url === null || url?.length === 0) && await Session.signOut();
    };
    checkConnection();
    window.addEventListener('online', checkConnection);
    window.addEventListener('offline', checkConnection);
    return () => {
      window.removeEventListener('online', checkConnection);
      window.removeEventListener('offline', checkConnection);
    };
  }, [props.layoutCondition]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCredentialError(false);
    // setError('');
    setFormError('');
    setAlert(false);
    const { name, value } = e.target;
    if (e.target.type == 'email') {
      const email = e.target.value;
      sessionStorage.setItem('userEmail', email);
    }; setUser(prevUser => ({ ...prevUser, [name]: value }));
  };

  async function getToken(): Promise<void> {
    const accessToken = await Session.getAccessToken();
    console.log("Access Token: ", accessToken)
  }

  const setSessionDetails = async () => {
    try {
      const token = await Session.getAccessToken
      sessionStorage.setItem('user-login', String(token));
      const sessionResponse = await apiCall('/sessioninfo', undefined, 'GET');
      // if (!sessionResponse.ok) { throw new Error("Network response was not ok") }
      // const sessionData = await sessionResponse.json();
      const sessionData = sessionResponse;
      console.log("Session info: ", sessionData);
      console.log("Role assigned: ", sessionData.accessTokenPayload["st-role"].v[0]);
      sessionStorage.setItem("role", sessionData.accessTokenPayload["st-role"].v[0]);
      const loadRoute = async () => {
        try {
          const [routeAllowed, permissions] = await shouldLoadRoute(sessionData.accessTokenPayload["st-role"].v[0]);
          if (routeAllowed) {
            console.log("Permission: ", permissions);
            setPermissions(permissions);
          } else {
            console.log("Route is not allowed...");
          }
        } catch (error) {
          console.error("Error loading route: ", error);
        }
      };
      loadRoute();
    } catch (error) {
      setIsDisabled(false);
      console.error("Error fetching session info: ", error);
    }
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    // To disable sing in button for error handling.
    setIsDisabled(true);
    setError('');
    setAlert(false);
    setCredentialError(false);
    setFormError('');
    setIsLoading(true); // Set loading state when sign-in process starts
    if (error) {
      setAlert(true);
      setIsDisabled(false);
      console.log('Error: ', error);
    }
    try {
      let response = await signIn({ formFields: [{ id: "email", value: user.username }, { id: "password", value: user.password }] })
      console.log('Status: ', response.status);
      if (response.status === "FIELD_ERROR") {
        console.log("Status: ", response.status)
        response.formFields.forEach(formField => {
          if (formField.id === "email") { // Email validation failed (for example incorrect email syntax). window.alert(formField.error)
            setIsDisabled(false);
            // setCredentialError(true);
            setFormError(formField.error);
            setIsLoading(false);
          }
        })
      } else if (response.status === "WRONG_CREDENTIALS_ERROR") { // window.alert("Email and Password combination is Incorrect.!")
        // userActivity("Login",`{"summary":"Wrong credentials entered"}`, 'failure');
        setFormError('');
        setIsDisabled(false);
        setCredentialError(true);
        setIsLoading(false);
      } else if (response.status === "SIGN_IN_NOT_ALLOWED") {
        // This can happen due to automatic account linking. Tell the user that their input credentials is wrong (so that they do through the password reset flow)
        setError('Signin not allowed');
        setIsDisabled(false);
      } else {
        // sign in successful. The session tokens are automatically handled by the frontend SDK.          
        // if (await Session.doesSessionExist()) { // User is logged in
        const token = await Session.getAccessToken;
        // getToken(); 
        ((url === undefined || url === null || url?.length === 0) && localStorage.getItem('LogedInFrom') === null) && localStorage.clear();
        sessionStorage.setItem('user-login', String(token));
        // setNavigate(true);
        console.log('Logged in successfully...')
        setIsLoading(true);
        let userDetails: any;
        try {
          const res = await apiCall('/get-user-info', undefined, 'GET'); // await response.json()
          console.log("JWT token: ", res);
          if (res.message !== "unauthorised") {
            const user_email: string = res?.emails[0];
            try {
              const response = await apiCall('/users/getUsersDetails', { user_email });
              const data = response.data;
              console.log("API data: ", data);
              if (data?.length > 0) {
                userDetails = data[0];
                console.log('User details: ', userDetails);
                localStorage.setItem('userDetails', JSON.stringify(userDetails));
                sessionStorage.setItem('userDetails', JSON.stringify(userDetails));
                contextValue.setUserSessionDetails({
                  userId: userDetails.userid,
                  userName: userDetails.firstName,
                  userLName: userDetails.lastName,
                  userEmail: userDetails.user_email,
                  otherDetails: JSON.parse(userDetails.formDataEdit),
                  rawData: userDetails,
                });
              }
            } catch (error) {
              console.error("An unexpected error occurred: ", (error as Error).message);
              setAlert(true);
            }
          }
        } catch (error) {
          console.error("Error fetching user info: ", error);
        }
        await setSessionDetails();
        setCredentialError(false);
        setBlockedError(false)
        setUserNotExistsError(false);
        console.log('User details: ', userDetails);
        if (redirectURL.length > 0) {
          const { status, data } = await apiCall('/ServiceNow/tenantOfMachine', { servicetag: machineName });
          if (status === "success" && data?.length > 0) {
            contextValue.setTenantName(data);
          }
          const { data: columnData, status: columnStatus } = await apiCall('/administration/getColumnData');
          if (columnStatus === "success" && columnData?.length > 0) {
            contextValue.setTableColumnsData(columnData[0]);
            localStorage.setItem("tableColumnsData", JSON.stringify(columnData[0]));
          }
          localStorage.setItem("LogedInFrom", JSON.stringify({ "platform": "ServiceNow", "device": machineName }));
          contextValue.setLogedInFrom({ ...contextValue.logedInFrom, "platform": "ServiceNow", "device": machineName });
          await serviceNowRedirection();
        } else if (userDetails.securityType === 'Email' || userDetails.securityType === 'emailotp') {
          checkOTPAndRedirect();
          let resp: any = await sendOTP(user.username);
          if (resp == 'success') {
            Navigate('/verifyotp');
          } else {
            setIsDisabled(false);
            setFormError(`Error in OTP sending`);
            Navigate('/');
          }
        } else {
          console.log("I'm in final step...")
          Navigate("/home");
        }
        console.log("I'm in dashboard...");
      }
    } catch (err: any) {
      // console.log('error - ',err);
      setIsDisabled(false);
      if (err.isSuperTokensGeneralError === true) {
        console.log('Error: ', err.message);
        setIsLoading(false);
        setFormError(err.message);
        if (err && err.message && err.message.includes("Your account has been blocked.")) {
          sendMail(user.username, "blockedAccount");
        }
        // window.alert(err.message); // this may be a custom error message sent from the API by you.
      } else { // window.alert("Oops! Something went wrong."); 
        setIsLoading(false);
        setAlert(true);
        setIsLoading(false);
        console.log("Error: ", err);
      }
    }
  };

  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  };

  // SSO click function
  async function ssoSignInClicked(provider: string) {
    // deleteCookie('sAccessToken');
    // await Session.signOut(); 
    try {
      const authUrl = await getAuthorisationURLWithQueryParamsAndSetState({
        thirdPartyId: provider,
        // This is where Google should redirect the user back after login or error.
        // This URL goes on the Google's dashboard as well.
        // frontendRedirectURI: encodeURIComponent(`http://localhost:3000/auth/callback/${provider}`),
        frontendRedirectURI: `${AppConfig.DASHBOARD_V2_API_URL}/auth/callback/${provider}`
      });
      // Example value of authUrl: https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fuserinfo.email&access_type=offline&include_granted_scopes=true&response_type=code&client_id=1060725074195-kmeum4crr01uirfl2op9kd5acmi9jutn.apps.googleusercontent.com&state=5a489996a28cafc83ddff&redirect_uri=https%3A%2F%2Fsupertokens.io%2Fdev%2Foauth%2Fredirect-to-app&flowName=GeneralOAuthFlow
      // we redirect the user to google for auth.
      window.location.assign(authUrl);
    } catch (err: any) {
      if (err.isSuperTokensGeneralError === true) {
        // this may be a custom error message sent from the API by you.
        // window.alert(err.message);
        setFormError(err.message);
      } else {
        // window.alert("Oops! Something went wrong with SSO.");
        //Cookies.remove('sAccessToken');
        setAlert(true);
      }
    }
  }

  // Add these event handlers at the component level, before the return statement
  const preventCopyPaste = (e: ClipboardEvent) => {
    e.preventDefault();
    return false;
  };

  const preventCut = (e: ClipboardEvent) => {
    e.preventDefault();
    return false;
  };

  const extra = <StackItem><Text /></StackItem>;

  const authForm = () => {
    const loginData = () => {
      const passwordExtra = (passwordFocused && !hasNativePasswordToggle() &&
        <Button
          id="eye"
          size="small"
          appearance='transparent'
          onClick={handleTogglePassword}
          icon={
            <Tooltip withArrow content={showPassword ? "Hide Password" : "Show Password"} relationship="label">
              {showPassword ? <EyeOff20Filled /> : <Eye20Filled />}
            </Tooltip>
          }
        />
      );

      const badgesData = () => {
        const DangerInfo = ({ children }) => (<Badge appearance="ghost" color="danger"> <Body2> {children} </Body2> </Badge>);
        return (
          <Stack disableShrink>
            {error && (<Badge appearance="ghost" color="informative"> <Body2> {error} {showLink && <Link onClick={() => Navigate("/auth/reset-password")}>click here</Link>} </Body2> </Badge>)}
            {formError && <DangerInfo> {formError} </DangerInfo>}
            {credentialError && <DangerInfo> The username or password is incorrect! </DangerInfo>}
            {isAltert && <DangerInfo> Oops! Something went wrong. </DangerInfo>}
            {blockedError && <DangerInfo> Your account has be blocked. kindly reset password </DangerInfo>}
            {userNotExistsError && <DangerInfo> Email ID Does Not Exist. </DangerInfo>}
          </Stack>
        );
      };

      const extra1 = (
        <>
          {extra}
          <StackItem> {isLoading && <Spinner delay={1000} size='extra-tiny' label="Please wait...." />} </StackItem>
          <StackItem> <Open20Regular onClick={() => Navigate("/auth/reset-password")} /> </StackItem>
        </>
      );

      const extra2 = (
        <>
          {extra}
          <Stack horizontal tokens={{ childrenGap: 10 }}>
            <StackItem> <Body1> Don't have an account? </Body1> </StackItem>
            <StackItem> <Link onClick={() => Navigate("/signup")}> <Body1Strong> Sign Up </Body1Strong> </Link> </StackItem>
          </Stack>
          <Stack horizontal tokens={{ childrenGap: 10 }}>
            <StackItem> <Body1> REMOVE ME AND ADD ME IN HEADER </Body1> </StackItem>
            <StackItem> <Link onClick={() => Navigate("/auth/change-password")}> <Body1Strong> Change Password </Body1Strong> </Link> </StackItem>
          </Stack>
          <Stack horizontalAlign='start'> {isLoading && <Spinner delay={1000} size='extra-tiny' label="Please wait...." />} </Stack>
          <Stack horizontalAlign='start'> {isLoading && <Spinner delay={1000} size='huge' label="Please wait...." />} </Stack> <Divider alignContent='start'> <Body1> <Button shape="circular" size='small' appearance='transparent' /*onClick={handleButtons}*/> Other Options </Button> </Body1> </Divider>
          <Divider />
        </>
      );

      const extra3 = (
        <>
          <StackItem>
            <Button shape="circular" size="medium" /*onClick={toggleForm}*/>
              <Body1> {/* {showMagicLinkForm ? "Email /Password" : "Magic Link / OTP"} */} </Body1>
            </Button>
          </StackItem>
          <StackItem>
            <Button shape="circular" size="medium" onClick={() => ssoSignInClicked("apple")}>
              <Body1> Sign In with Apple </Body1>
            </Button>
          </StackItem>
        </>
      );

      const extra4 = /*!showMagicLinkForm &&*/ (
        <StackItem grow shrink>
          <Stack tokens={{ childrenGap: 5 }} horizontalAlign="center">
            <StackItem>
              <Button shape="circular" size="medium" onClick={() => ssoSignInClicked("google")}>
                <Body1> Sign In with Google </Body1>
              </Button>
            </StackItem>
            <StackItem>
              <Button shape="circular" size="medium" onClick={() => ssoSignInClicked("github")}>
                <Body1> Sign In with GitHub </Body1>
              </Button>
            </StackItem>
            <StackItem>
              <Button shape="circular" size="medium" onClick={() => ssoSignInClicked("okta")}>
                <Body1> Sign In with Okta </Body1>
              </Button>
            </StackItem>
          </Stack>
        </StackItem>
      );

      return !loginPage
        ? (<>
          <Body1> Username </Body1>
          <Input type='email' id="username" name="username" placeholder='Enter Username' value={user.username} onChange={handleInputChange} disabled={isDisabled} required style={whites} />

          <Body1> Password </Body1>
          <Input id="password" name="password" placeholder='Enter Password' value={user.password} onChange={handleInputChange} onFocus={handlePasswordFocus} onPaste={preventCopyPaste} onCopy={preventCopyPaste} onCut={preventCut} type={showPassword ? 'text' : 'password'} required disabled={isDisabled} contentAfter={passwordExtra} style={whites} />

          {badgesData()}

          <Link to="/auth/reset-password">
            <Stack horizontal tokens={{ childrenGap: 40 }}>
              <StackItem > <Body1 underline onClick={() => Navigate("/auth/reset-password")}> Forgot Password? </Body1> </StackItem>
              {/* {extra1} */}
            </Stack>
          </Link>

          <Stack grow>
            <Button shape="circular" id="signInBtn" ref={signInButtonRef} appearance="primary" type="submit" disabled={isLoading /*|| isDisabled*/}>
              {isLoading ? (
                <Stack horizontal horizontalAlign="center" verticalAlign="center" tokens={{ childrenGap: 8 }}>
                  <Spinner delay={1000} size="extra-tiny" />
                  <Body1Strong> Signing In... </Body1Strong>
                </Stack>
              ) : <Body1Strong> Sign In </Body1Strong>}
            </Button>
          </Stack>

          {/* {extra2} */}

          {!SSODisabled &&
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem grow shrink>
                <Stack tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  {/* {extra3} */}
                  <Divider appearance="strong"> OR </Divider>
                  {extra}
                  {extra}
                  <StackItem>
                    <Button shape="circular" disabled={isDisabled} size="medium" onClick={() => ssoSignInClicked(provider)}>
                      <Body1> Sign In with SSO </Body1>
                    </Button>
                  </StackItem>
                </Stack>
              </StackItem>
              {extra}
              {/* {extra4} */}
            </Stack>}

          {showButton &&
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem grow shrink>
                <Stack tokens={{ childrenGap: 5 }} horizontalAlign='center'>
                  <StackItem> <Button shape="circular" size='small' onClick={EnablePage}> <Body1Strong> Magic Link / OTP </Body1Strong> </Button> </StackItem>
                  <StackItem> <Button shape="circular" size='small'> <Body1Strong> Sign in with Apple </Body1Strong> </Button> </StackItem>
                </Stack>
              </StackItem>
              <StackItem grow shrink>
                <Stack tokens={{ childrenGap: 5 }} horizontalAlign='center'>
                  <StackItem> <Button shape="circular" size='small'> <Body1Strong> Sign in with Google </Body1Strong> </Button> </StackItem>
                  <StackItem> <Button shape="circular" size='small'> <Body1Strong> Sign in with GitHub </Body1Strong> </Button> </StackItem>
                </Stack>
              </StackItem>
            </Stack>}
        </>)
        : submissionPage
          ? (<>
            <Input type='email' id="username" name="username" placeholder='Enter OTP' value={user.username} onChange={handleInputChange} />
            <StackItem> <Button shape="circular" type="submit"> <Body1Strong> Submit OTP </Body1Strong> </Button> </StackItem>
            <StackItem> <Button shape="circular" type="submit"> <Body1Strong> Change Email / Phone </Body1Strong> </Button> </StackItem>
            <StackItem> <Button shape="circular" type="submit"> <Body1Strong> Resend OTP / Link </Body1Strong> </Button> </StackItem>
          </>)
          : (<>
            <Body2> Email / Phone </Body2>
            <Input type='email' id="username" name="username" placeholder='Enter Email or Phone' value={user.username} onChange={handleInputChange} />
            <StackItem>
              <Button shape="circular" appearance='primary' type="submit" onClick={SubmissionPageEnable}>
                <Body1Strong> Send Magic Link / OTP </Body1Strong>
              </Button>
            </StackItem>
            <StackItem> <Button shape="circular" type="submit"> <Body1Strong> Email / Password </Body1Strong> </Button> </StackItem>
          </>)
    }

    return (
      <form onSubmit={handleSubmit}>
        <Card style={cardRadius}>
          <StackItem align="center"> <Image src="/Dashboard/image/signinLogo.svg" alt='Nanoheal Logo' /> </StackItem>
          <StackItem align="center"> <Text weight="regular" > Hello there! Please input your details to Proceed </Text> </StackItem>
          {loginData()}
        </Card>
      </form>
    );
  };

  return !isOnline ? <SkeletonSignin /> :
    <FluentProvider style={{ ...parentHome, ...newBackground }} theme={newLightTheme}>
      <Stack horizontal style={parentHome}>
        <StackItem>
          <Dialog open={redirectURL.length > 0 && isDisabled ? true : false}>
            <DialogSurface style={{ maxWidth: "20vw" }}>
              <DialogBody>
                <DialogTitle> Logging In </DialogTitle>
                <DialogContent> Please wait... </DialogContent>
              </DialogBody>
            </DialogSurface>
          </Dialog>
        </StackItem>
        <Stack style={halfWidth} verticalAlign="center" horizontalAlign="center">
          <Stack tokens={{ childrenGap: 15 }}> {authForm()} </Stack>
          <Stack style={backgroundPosition}> <Image block src="/Dashboard/authBackground.png" alt='Background Image' height="100%" /> </Stack>
        </Stack>
      </Stack>
    </FluentProvider>
};
